// src/utils/buyerActivity.js
// Pure, Firebase-free helpers for the Buyer Lead Tracker: activity types,
// A/B/C rating, and follow-up due/sort logic. Dates are ISO "YYYY-MM-DD"
// strings (lexicographic order == chronological), so `today` is injected.

export const ACTIVITY_TYPES = ["Call", "Text", "Email", "Note", "Meeting"];
export const RATING_OPTIONS = ["A", "B", "C"];

const RATING_COLORS = {
  A: "bg-red-100 text-red-700",
  B: "bg-amber-100 text-amber-700",
  C: "bg-slate-100 text-slate-600",
};
export const getRatingColor = (r) => RATING_COLORS[r] || "";

export function followUpStatus(lead, todayIso) {
  const d = lead?.nextFollowUp;
  if (!d) return "none";
  if (d < todayIso) return "overdue";
  if (d === todayIso) return "today";
  return "upcoming";
}

export function isFollowUpDue(lead, todayIso) {
  const s = followUpStatus(lead, todayIso);
  return s === "overdue" || s === "today";
}

// Soonest nextFollowUp first; leads with no date sort last.
export function sortByFollowUp(leads = []) {
  return [...leads].sort((a, b) => {
    const da = a?.nextFollowUp || "";
    const db = b?.nextFollowUp || "";
    if (!da && !db) return 0;
    if (!da) return 1;
    if (!db) return -1;
    return da.localeCompare(db);
  });
}

// id + at are injected by the caller so this stays pure/testable.
export function newActivity({ type, note = "", by = "", byName = "", id, at }) {
  return { id, type, note: (note || "").trim(), by, byName, at };
}

// Today (or `fromIso`) + `days`, as ISO "YYYY-MM-DD" in LOCAL time — used by the
// follow-up snooze presets (Tomorrow / +3 / +1 week).
export function addDaysIso(days, fromIso) {
  const base = fromIso ? new Date(`${fromIso}T00:00:00`) : new Date();
  base.setDate(base.getDate() + days);
  const m = String(base.getMonth() + 1).padStart(2, "0");
  const d = String(base.getDate()).padStart(2, "0");
  return `${base.getFullYear()}-${m}-${d}`;
}
